
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinnashik() {



const cardData = {
  keyword: 'Corporate Cab Services in Nashik',
  heading: 'eTravo: Corporate Cab Services in Nashik',
  headingDescription: `eTravo proudly offers reliable and efficient corporate cab services in Nashik, designed to support the diverse transportation needs of businesses, industrial units, and professionals in one of Maharashtra’s rapidly growing cities. From daily employee commutes and executive transfers to client pickups and event logistics, our fleet of GPS-enabled, air-conditioned vehicles ensures every journey is safe, punctual, and comfortable. Driven by trained, professional chauffeurs who follow corporate etiquette, eTravo provides flexible rental plans, optimized routes, and 24/7 customer assistance. Whether serving IT parks, manufacturing hubs, or business centers across Nashik, eTravo is your trusted partner for seamless and professional corporate mobility solutions.`,

  top: 'Top Places to visit in Nashik with eTravo',
     "topPlaces": [
    {
      "title": "Nashik MIDC Industrial Areas",
      "description": "Nashik hosts several prominent MIDC industrial zones, including Satpur, Ambad, and Sinnar, accommodating a diverse range of industries such as engineering, automotive, pharmaceuticals, and food processing. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Nashik City Center",
      "description": "The commercial and administrative heart of Nashik, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Nashik Road Railway Station",
      "description": "A crucial railway hub connecting Nashik with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Nashik-Sinnar Logistics Hub",
      "description": "An emerging logistics center enhancing the region's warehousing and transportation capabilities. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Yashwantrao Chavan Maharashtra Open University (YCMOU)",
      "description": "A premier educational institution attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Government Medical College, Nashik",
      "description": "A key healthcare and educational institution in the region. eTravo provides dependable cab services for medical professionals, students, and patients, ensuring timely arrivals and departures for critical healthcare services."
    },
    {
      "title": "City Centre Mall, Nashik",
      "description": "A popular shopping destination in Nashik, offering a variety of retail outlets and entertainment options. eTravo facilitates transportation for shoppers and retail employees, enhancing the shopping experience with convenient and safe travel options."
    },
    {
      "title": "The Gateway Hotel Ambad, Nashik",
      "description": "A renowned hospitality establishment in Nashik. eTravo provides transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry."
    },
    {
      "title": "K.K. Wagh Institute of Engineering Education and Research",
      "description": "An esteemed educational institution offering quality engineering education. eTravo provides transportation solutions for students and faculty members, ensuring safe and timely commutes."
    },
    {
      "title": "Wockhardt Hospital, Nashik",
      "description": "A multi-specialty hospital serving the healthcare needs of Nashik residents. eTravo offers reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics."
    }
  ],

services: [
  {
    name: 'Nashik Corporate Cab Rentals',
    description: `Specialized corporate cab rental services crafted to meet the daily and occasional transportation needs of businesses in Nashik. Whether it’s long-term staff commuting, event transport, or temporary vehicle deployment, we offer a well-maintained fleet backed by corporate-grade service and flexible rental plans.`
  },
  {
    name: 'Employee Transport Cab Nashik',
    description: `Efficient and dependable cab service designed to transport employees safely and punctually across Nashik. Our vehicles are GPS-tracked and adhere to shift schedules, ensuring your staff reaches the workplace on time, every time—day or night.`
  },
  {
    name: 'Business Cab Services Nashik',
    description: `Business-focused cab services for executives, managers, and field personnel. Whether traveling for internal meetings or external appointments, our experienced drivers and quick dispatch system ensure reliable and comfortable trips throughout the city.`
  },
  {
    name: 'Corporate Staff Cabs Nashik',
    description: `Structured multi-route cab services with real-time tracking to facilitate group transport for office teams or factory staff. Our service improves efficiency, promotes employee well-being, and reduces vehicle redundancy through travel.`
  },
  {
    name: 'Reliable Corporate Cab Service Nashik',
    description: `A trusted solution for corporate travel needs, delivering consistently clean cars, courteous drivers, and timely service. Perfect for companies who value punctuality and professionalism in their transport partner.`
  },
  {
    name: 'AC Corporate Cabs Nashik',
    description: `Our air-conditioned cabs offer a comfortable and quiet ride, regardless of Nashik’s climate. Ideal for regular commutes or premium employee transfers, our AC fleet ensures a fresh, relaxed experience from pickup to drop.`
  },
  {
    name: 'Staff Pickup and Drop Cab Nashik',
    description: `Round-the-clock pickup and drop solutions for staff working in multiple shifts, including night duties. This service helps maintain smooth business operations while ensuring staff travel safely and on time.`
  },
  {
    name: 'Affordable Business Cab Rentals Nashik',
    description: `Economical and transparent cab rental solutions tailored for SMBs and enterprises. Scale your cab usage up or down based on daily demands, seasonal needs, or operational changes—without compromising service quality.`
  },
  {
    name: 'Executive Cab Services Nashik',
    description: `Premium cabs with luxury interiors and highly trained chauffeurs for senior management, clients, or business guests. Ideal for high-stake meetings, airport transfers, and corporate hospitality with discreet, top-tier service.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Nashik',
    description: `Pre-arranged monthly transport plans with fixed routes and consistent vehicles to simplify employee commuting. Ideal for HR and admin teams looking to reduce workload, manage budgets efficiently, and ensure reliable daily service.`
  },
  {
    name: 'Industrial Area Employee Transport Nashik',
    description: `Cab solutions tailored for factory and plant workers in Nashik’s industrial zones. Our vehicles and drivers are compliant with safety standards, and our route optimization tools ensure minimum delays and maximum operational efficiency.`
  },
  {
    name: 'Corporate Client Cabs Nashik',
    description: `Polished cab service for visiting clients, featuring executive-grade vehicles and professional drivers. Whether it’s airport transfers, hotel pickups, or site tours, we help make the best first impression for your business.`
  },
  {
    name: 'Business Meeting Cabs Nashik',
    description: `Reliable, on-demand cab services for executives attending time-sensitive meetings. Book quickly and travel comfortably to locations across Nashik and surrounding regions with our prompt, professional support team.`
  },
  {
    name: 'Nashik Corporate Vehicle Hire',
    description: `Flexible vehicle hire service for short-term or on-call corporate needs. From luxury sedans for leadership to utility cabs for field visits, our fleet is ready to meet any ad-hoc requirement your team might have.`
  },
  {
    name: 'Corporate Shuttle Cabs Nashik',
    description: `Group shuttle cab services using minibuses or vans, perfect for shift changes, off-site team movements, or large corporate gatherings. Improve coordination and reduce transport costs with cab solutions.`
  }
],

tableData: [
  ['Nashik Corporate Cab Rentals', 'Employee Transport Cab Nashik'],
  ['Business Cab Services Nashik', 'Corporate Staff Cabs Nashik'],
  ['Reliable Corporate Cab Service Nashik', 'AC Corporate Cabs Nashik'],
  ['Staff Pickup and Drop Cab Nashik', 'Affordable Business Cab Rentals Nashik'],
  ['Executive Cab Services Nashik', 'Monthly Corporate Cab Rentals Nashik'],
  ['Industrial Area Employee Transport Nashik', 'Corporate Client Cabs Nashik'],
  ['Business Meeting Cabs Nashik', 'Nashik Corporate Vehicle Hire'],
  ['Corporate Shuttle Cabs Nashik', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Corporate Cab Services for Nashik",
    "WhyChoosedescription": "eTravo offers premium corporate cab solutions customized for businesses in Nashik, a rapidly expanding industrial and commercial city. Our services are designed to ensure smooth employee commutes, timely transportation, and enhanced organizational productivity."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our diverse fleet includes sedans, SUVs, and multi-utility vehicles, offering flexibility for various business transportation needs—from daily staff transport to executive and VIP travel."
  },
  {
    "WhyChooseheading": "Experienced Drivers with In-Depth Local Knowledge",
    "WhyChoosedescription": "Our professional drivers are well-trained and possess excellent knowledge of Nashik’s roads, industrial zones, and traffic patterns, ensuring prompt and efficient service with corporate-level etiquette."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Shift-Based Operations",
    "WhyChoosedescription": "We offer flexible booking models tailored to businesses operating in shifts. Whether you need scheduled rides, on-demand service, or contract-based arrangements, we’ve got you covered."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Visibility",
    "WhyChoosedescription": "All vehicles are GPS-enabled, allowing live tracking for safety, route transparency, and real-time updates—providing peace of mind to both employees and employers."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoicing",
    "WhyChoosedescription": "Our transparent billing system includes detailed trip records and fare breakdowns, making corporate accounting and reimbursement simple and hassle-free."
  },
  {
    "WhyChooseheading": "High Standards for Safety and Hygiene",
    "WhyChoosedescription": "We follow strict safety and hygiene protocols, including regular sanitization of vehicles and health checks for drivers, ensuring a safe and clean environment for every ride."
  },
  {
    "WhyChooseheading": "Dedicated Account Management for Corporate Clients",
    "WhyChoosedescription": "Each client is supported by a dedicated account manager to streamline bookings, offer ongoing support, and deliver a seamless cab service experience throughout Nashik."
  }
]










}

const faqData = [
  [
    {
      question: "Which areas do your Nashik corporate cab services cover?",
      answer: "Our services span the entire Nashik region including industrial zones like Ambad MIDC, Satpur MIDC, and nearby business parks."
    },
    {
      question: "Do you support cab scheduling for multiple employee shifts?",
      answer: "Yes, we provide shift-based scheduling for fixed, rotating, and night shifts to ensure seamless employee transportation."
    },
    {
      question: "Is consolidated billing provided for corporate clients?",
      answer: "Absolutely. We offer GST-compliant monthly billing along with detailed trip logs to simplify your financial reconciliation."
    },
    {
      question: "Are your drivers trained to serve corporate clients?",
      answer: "Yes, our drivers are professionally trained in corporate etiquette, safety standards, and familiar with all key routes in Nashik."
    },
    {
      question: "What measures are in place to ensure ride safety?",
      answer: "We ensure safety with GPS tracking, sanitized and inspected vehicles, background-verified drivers, and 24/7 customer support."
    },
    {
      question: "Do corporate clients get priority support?",
      answer: "Yes, each corporate account is assigned a dedicated account manager for quick resolution and personalized assistance."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Sandeep Bhagat",
    designation: "Logistics Head, Nashik Auto Components",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s cab services in Nashik have brought unmatched reliability and convenience to our employee transportation.”"
  },
  {
    name: "Ms. Pooja Shingne",
    designation: "HR Manager, Nashik Food & Beverages Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“We rely on eTravo for safe, punctual, and professional cab services for our staff. Excellent experience so far!”"
  }
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Nashik",
  "image": "https://www.etravo.in/images/keyword/cab-service-nashik.jpg",
  "description": "Reliable corporate cab service in Nashik offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-nashik"
  }
};








    return (
        <div>
<Helmet>
  <title>Corporate Cab Services in Nashik | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Nashik for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/93.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinnashik;